export default __webpack_public_path__ + "static/media/0logo-removebg-preview.59e0f835.png";